import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import Routes from "Routes";
import GlobalStyles from "Styles/GlobalStyles";

ReactDOM.render(
  <Fragment>
    <Routes />
    <GlobalStyles />
  </Fragment>,
  document.getElementById("root")
);
